module.exports = __webpack_public_path__ + "static/mo42-d5f9de3b37512ed5f5d2d749435c4a60.png";